export default class Store {
  constructor(name, shortName, address) {
    this.name = name;
    this.shortName = shortName;
    this.address = address;
  }
}